export default __webpack_public_path__ + "static/media/chevrons-right.84c7facc.svg";